const getPopupCode = ({ checkoutUrl, overlayUrl }) => {
  const scriptCode = `<script type="text/javascript" src="${overlayUrl}" async></script>`;
  const popUpCode = `<a href="${checkoutUrl}" class="cp-button">Buy now</a>`;

  return {
    scriptCode,
    popUpCode,
  };
};

export default getPopupCode;
